import { ICoreContext } from '@msdyn365-commerce/core';
import { useEffect } from 'react';
import { UserCentricsService } from '../../../../integrations/userCentrics/UserCentricsService';
import { syncGenderCookie } from '../gender-cookie-service';
import { Gender } from '../gender-cookie-service.types';

export const useSyncGenderCookie = (pageGender: Gender | undefined, context: ICoreContext): void => {
    useEffect(() => {
        const synchronize = async (): Promise<void> => {
            try {
                await syncGenderCookie(context, pageGender);
            } catch (error) {
                context.telemetry.warning(`Gender cookie synchronization failed: ${String(error)}`);
            }
        };

        return UserCentricsService.subscribeToUCInitialized(synchronize);
    }, [context, pageGender]);
};
